// todo move appconfig to common

import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app';
import StripTypeConfig from '../config/StripTypeConfig';
import BannerTypeConfig from '../config/BannerTypeConfig';
import PhoneNumberConfig from '../config/PhoneNumberConfig';
import AuchanShopAreaSprite from '~~/shop/assets/icons/auchan-shop-area.svg';
import defaultImage from '~~/common/assets/images/shop-entity-default.jpg';
import SimpleWidgetTypeConfig from '~~/common/config/SimpleWidgetTypeConfig';
import { useNameOrderConfig } from '~~/shop/config/NameOrderConfig';

import markerImage from '~~/common/assets/images/auchan_A_marker.svg';

const THROTTLE_TIMEOUT = 400;
const URL_PREFIX = '/shop';
const IS_SHOP = true;

const DELIVERY_AREA_MODEL = {
  PUBLIC_AREA: 'public_area',
  PICK_UP_FROM_STORE: 'department_store',
};

const DELIVERY_METHODS = {
  DELIVERY_CLICK_AND_COLLECT: 'delivery_click_and_collect',
  GLS_PICKUP: 'delivery_gls_pickup',
  GLS_LOCKER: 'delivery_gls_locker',
  DELIVERY_ADDRESS: 'delivery_address',
  DELIVERY_FOXPOST_LOCKER: 'delivery_foxpost_locker',
  DELIVERY_PICKUP_OR_LOCKER: 'delivery_pickup_or_locker',
  DELIVERY_PICKUP: 'delivery_pickup',
  DELIVERY_LOCKER: 'delivery_locker',
};

const PAYMENT_METHODS = {
  ONSITE: 'onsite',
  ONLINE_CREDIT_CARD: 'onlineCreditCard',
  ONLINE: 'online',
  CREDIT: 'credit',
};

const PAYMENT_STATUSES = {
  PAYMENT_STATUS_OFFLINE: 'offline',
  PAYMENT_STATUS_PAID: 'paid',
  PAYMENT_STATUS_IN_PROGRESS: 'inProgress',
  PAYMENT_STATUS_FAILED: 'failed',
};

const YOUTUBE_IMAGE_URL_PREFIX = 'https://img.youtube.com/vi/';

const YOUTUBE_IMAGE_VARIATIONS = ['/maxresdefault.jpg'];

const DEFAULT_RANGE_FILTER_NUMBER_LIMIT = 15;

// input components size for: common/mixins/addressFormMixin.js
const INPUT_SIZE = 'lg';
const INPUT_LABEL_PLACE_OUTER = false;

const CMS_PAGE_MENU_WRAPPER_COMPONENTS_MAP = {
  'career-menu': 'aw-career-menu',
  'petrol-menu': 'aw-petrol-menu',
  'loyalty-program-menu': 'aw-loyalty-program-menu',
};

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const osmFullUrl = config.public.osmFullUrl;
  const appConfig = {
    NameOrderConfig: useNameOrderConfig(),
    StripTypeConfig,
    BannerTypeConfig,
    PhoneNumberConfig,
    ModalConfig: {
      closeIconAttrs: {
        name: 'times-16',
        size: 16,
      },
    },
    SimpleWidgetTypeConfig,
    defaultImage,
    AuchanShopAreaSprite,
    OSMConfig: {
      tileLayer: [
        osmFullUrl,
        {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        },
      ],
      icon: {
        iconUrl: markerImage,
        iconSize: [52, 64],
        iconAnchor: [26, 64],
        popupAnchor: [0, -64],
      },
    },
  };

  nuxtApp.provide('appConfig', appConfig);
});

export {
  IS_SHOP,
  THROTTLE_TIMEOUT,
  YOUTUBE_IMAGE_URL_PREFIX,
  YOUTUBE_IMAGE_VARIATIONS,
  URL_PREFIX,
  DELIVERY_AREA_MODEL,
  DELIVERY_METHODS,
  PAYMENT_METHODS,
  INPUT_SIZE,
  INPUT_LABEL_PLACE_OUTER,
  DEFAULT_RANGE_FILTER_NUMBER_LIMIT,
  PAYMENT_STATUSES,
  CMS_PAGE_MENU_WRAPPER_COMPONENTS_MAP,
};
